import styled from 'styled-components';

export const Wrapper = styled.div`
  box-sizing: border-box;
  // font-family:inherit;
  font-family: inherit;
  width: 100%;
  padding: 30px;
  height: 100%;
  text-align: left;
`;

export const TopicDiv = styled.span`
  height: 25px;
  display: flex;
  position: relative;
  flex-direction: row;
  text-align: left;
  // color: #636363;
  color: ${(props)=>props?.heading ? props?.heading : '#000000'};
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
`;

export const Desc = styled.div`
  // color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  margin-top: 5px;
  color: #2a2929;
  font-family: inherit;
    text-transform: capitalize;
`;

export const NewTopic = styled.div`
  box-sizing: border-box;
  margin: 30px 0;
  width: 98%;
  padding: 10px 25px 30px 25px;
  background: #f0fff0;
  border-radius: 15px;
`;

export const NewTopicSpan = styled.h3`
  // color: #353cf7;
  color: var(--Headlines, rgba(42, 136, 107, 1));

  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
`;

export const NewTopicDesc = styled.p`
  // color: #626262;
  color: #2a2929;
  font-size: 16px;
  font-weight: 400;
  line-height: 25px;
  margin: 22px 0 30px 0;
  font-family:inherit;
    text-transform: capitalize;
`;

export const NewButton = styled.button`
  // background: #353cf7;
  background: linear-gradient(95.02deg, #a0d925 -65.35%, #006a68 100%);
  border-radius: 100px;
  border: none;
  color: #fff;
  font-family: inherit;
  font-size: 18px;
  font-weight: 600;
  padding: 8px 26px;
  cursor: pointer;
  min-height: 44px;
  border-radius: 10px;
`;

export const ActiveTopic = styled.div`
  .topicWrapper {
    display: flex;
    gap: 20px 5px;
    cursor: pointer;
    flex-wrap: wrap;
    margin-bottom: 50px;
    
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const Heading = styled.p`
  color: #2a2929;
  font-size: 16px;
  font-weight: 700;
  font-family: inherit;
  text-transform: capitalize;

`;

export const ActiveTopicDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // background: #353cf75e;
  background: linear-gradient(180deg, #0d7362 0%, #4d9f47 100%);
  box-shadow: 0px 4px 4px 0px rgba(14, 88, 152, 0.25);

    text-transform: capitalize;
  width: 131px;
  height: 84px;
  border-radius: 10px;

  font-family: inherit;
  font-weight: 500;
  font-size: 18px;
  padding: 15px 20px;

  & > p {
    width: 131px; /* Fixed width */
    height: 84px; /* Fixed height */
    line-height: 84px; /* Centers text vertically */
    text-align: center; /* Centers text horizontally */
    overflow: hidden; /* Clips overflowed text */
    white-space: nowrap; /* Prevents text from wrapping */
    text-overflow: ellipsis; /* Adds ellipsis (…) for overflow */
    padding: 0 8px;
    color: white;
    font-family: inherit;
  }
`;


export const ActiveTopicDiv2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  // background: #353cf75e;
  background: linear-gradient(180deg, #0d7362 0%, #4d9f47 100%);
  box-shadow: 0px 4px 4px 0px rgba(14, 88, 152, 0.25);

  position: relative;
  text-transform: capitalize;
  // min-width: 131px;
  // height: 45px;
  
  // max-width: 310px;
  width: 192px;
  height: 75px;
  border-radius: 10px;

  font-family: inherit;
  font-weight: 500;
  font-size: 18px;
  padding: 15px 20px;
  
    display: flex;
    grid-template-columns: ${(p) => p?.channel == 'instagram' ? '45px 1fr' : '1fr'};

  & > p {
    width: 220px; /* Fixed width */
    height: 84px; /* Fixed height */
    // line-height: 84px; /* Centers text vertically */
    text-align: center; /* Centers text horizontally */
    // overflow: hidden; /* Clips overflowed text */
    // white-space: nowrap; /* Prevents text from wrapping */
    // text-overflow: ellipsis; /* Adds ellipsis (…) for overflow */
    padding: 0px;
    color: white;
    font-family: inherit;
    
    display: flex;
    align-items: center;
    word-break: break-word;
    margin:0px;
    
    width: fit-content;
    justify-content: center;
    
  }
`;
